"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuRender = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactWindowSize = _interopRequireDefault(require("react-window-size"));
var _Main = require("./Main.style");
var _menuItems = require("../../../../../constants/menuItems");
var _CreditsMenuItem = _interopRequireDefault(require("../../../../CreditsMenuItem"));
var _SubMenuWithIframe = require("../../../../SubMenuWithIframe");
var _Item = _interopRequireDefault(require("../Item"));
const MenuRender = _ref => {
  let {
    testSectionKey,
    primaryItems,
    credits,
    onOpenSubMenu,
    onClose,
    hasBack,
    customRender,
    ModalComp
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, primaryItems.map((item, index) =>
  /*#__PURE__*/
  // @ts-ignore
  _react.default.createElement(_Item.default, Object.assign({
    testSectionKey: testSectionKey,
    key: item.text
  }, item, {
    onClick: () => onOpenSubMenu(index),
    onClose: onClose,
    ModalComp: ModalComp
  }))), customRender === _menuItems.CUSTOM_DROPDOWN_COMMODITIES && /*#__PURE__*/_react.default.createElement(_Main.Container, null, /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.SubMenuWithIframeCommodities, {
    showing: true,
    hasHeader: hasBack,
    isMobile: true
  })), customRender === _menuItems.CUSTOM_DROPDOWN_INTELLIGENCE_PAGES && /*#__PURE__*/_react.default.createElement(_Main.Container, null, /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.SubMenuWithIframeIntelligencePages, {
    showing: true,
    hasHeader: hasBack,
    isMobile: true
  })), credits && !hasBack && /*#__PURE__*/_react.default.createElement(_Main.CreditUsageWrapper, null, /*#__PURE__*/_react.default.createElement(_CreditsMenuItem.default, {
    link: credits.link,
    isMobile: true
  })));
};
exports.MenuRender = MenuRender;
var _default = exports.default = (0, _reactWindowSize.default)(MenuRender);